export const Types = {
  SET_IS_LOADING: 'loader/SET_IS_LOADING'
}